import { BaseModel } from './BaseModel';
import AssessmentStatus from './AssessmentStatus';
import Post from './Post';
import User from './User';
export class PostMark extends BaseModel {
  static get entity() {
    return 'post-marks';
  }

  static fields() {
    return {
      id: this.attr(null),
      marked_at: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      post_id: this.attr(null),
      post: this.belongsTo(Post, 'post_id'),
      user_id: this.attr(null),
      user: this.belongsTo(User, 'user_id')
    };
  }

  static isUserMarkedPost(postId, userId) {
    let isMarked = false;

    const userMark = this.query().where('post_id', postId).where('user_id', userId).first();

    if (userMark) {
      isMarked = userMark.marked_at !== null;

      const post = Post.query().find(postId);

      if (post.is_submission) {
        // cehck user assessment status
        const userAssessmentStatus = AssessmentStatus.query()
          .with('status')
          .where('post_id', postId)
          .where('user_id', userId)
          .first();

        if (userAssessmentStatus && userAssessmentStatus.status) {
          isMarked = userAssessmentStatus.status.isPassed;
        }
      }
    }

    return isMarked;
  }

  static calculatePostMarkedProgress(learningUnitId, userId) {
    const postIds = Post.query()
      .where('learning_unit_id', learningUnitId)
      .get()
      .map(({ id }) => id);

    if (!postIds.length) return 0;

    const postKeys = postIds.reduce((acc, postId) => {
      acc[postId] = true;
      return acc;
    }, {});

    const markedPostCount = this.query()
      .where('user_id', userId)
      .where((postMark) => postKeys[postMark.post_id] && postMark.marked_at !== null)
      .count();

    return Math.round((markedPostCount / postIds.length) * 100);
  }

  static apiConfig = {
    actions: {
      createOrUpdate(postId, userId, isMarked) {
        const body = {
          post_id: postId,
          user_id: userId,
          is_marked: isMarked
        };

        return this.post(`post-marks`, body);
      }
    }
  };
}

export default PostMark;
